<template>
    <div class="lms__superadmin_customer_service_sso_edit_mel_setup">
            <component-wrapper>
                <component-title :size="'medium'">Authentication</component-title>
            </component-wrapper>
            <form-text
                v-if="subscriptionUrls.acsUrl.length"
                :label="'acsUrl'"
                :name="'lms-superadmin-customer-service-sso-edit-mel-setup-acsUrl'"
                :read-only="true"
                :hint-button="true"
                :hint-button-copy="true"
                :value="subscriptionUrls.acsUrl"
            >Copy link
                <v-icon name="copy"></v-icon>
            </form-text>
            <form-text
                v-if="subscriptionUrls.entityId.length"
                :label="'entityId'"
                :name="'lms-superadmin-customer-service-sso-edit-mel-setup-entityId'"
                :read-only="true"
                :hint-button="true"
                :hint-button-copy="true"
                :value="subscriptionUrls.entityId"
            >Copy link
                <v-icon name="copy"></v-icon>
            </form-text>
            <component-title :size="'label'">Metadata</component-title>
            <component-button
                :name="'lms-superadmin-customer-service-sso-edit-mel-setup-download-metadata'"
                :icon="true"
                :icon-name="'download'"
                :icon-align="'right'"
                :align="'left'"
                :animate-loading="true"
                :animate-loading-event-name="'get-metadata'"
                @click="getSAMLMetadata"
            >Download metadata
            </component-button>
    </div>
</template>

<script>
import FormText from '@/components/default/forms/FormText'
import { validateBeforeRouteLeave, watchContentChangeEmit } from '@/helpers/mixins'
import { User } from '@/User'
import ComponentWrapper from '@/components/default/shared/ComponentWrapper'
import ComponentTitle from '@/components/default/shared/ComponentTitle'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  name: 'lms-superadmin-customer-service-sso-edit-mel-setup',
  components: {
    ComponentWrapper,
    ComponentButton,
    ComponentTitle,
    FormText
  },
  data () {
    return {
      user: new User()
    }
  },
  mixins: [validateBeforeRouteLeave, watchContentChangeEmit],
  computed: {
    subscriptionUrls () {
      return this.$store.getters.getEbsServiceSSOUrls
    }
  },
  methods: {
    getSAMLMetadata () {
      this.$store.dispatch('ebsServiceSSOGetSAMLMetadata').finally(() => {
        this.$eventBus.$emit('stop-get-metadata')
      })
    }
  },
  inject: ['$validator']
}
</script>
